import ClassRoomListPage from '../../modules/class-rooms/pages/ClassRoomListPage';
import StudentPage from '../../modules/users/pages/StudentPage';
import DashboardReport from './components/DashboardReport';

const DashboardPage = () => (
  <div className='card mb-7'>
    <div className='card-body'>
      <DashboardReport />
    </div>
  </div>
)

const DashboardWrapper = () => {
  return (
    <div className='row'>
      <div className='col-sm-12'>
        <DashboardPage />
      </div>
      <div className='col-sm-6'>
        <StudentPage />
      </div>
      <div className='col-sm-6'>

        <ClassRoomListPage />
      </div>
    </div>
  )
}

export { DashboardWrapper }
